import { ClientStatus } from '../types/client';
import { ClientStatusDTO } from '../types/dto/client-status.dto';

/**
 * Maps ClientStatusDTO (API format) to ClientStatus (domain model)
 */
export const mapClientStatusFromDTO = (dto: ClientStatusDTO): ClientStatus => {
  switch (dto) {
    case ClientStatusDTO.ACTIVE:
      return ClientStatus.Active;
    case ClientStatusDTO.ARCHIVED:
      return ClientStatus.Archived;
    default:
      return ClientStatus.Active;
  }
};

/**
 * Maps ClientStatus (domain model) to ClientStatusDTO (API format)
 */
export const mapClientStatusToDTO = (status: ClientStatus): ClientStatusDTO => {
  switch (status) {
    case ClientStatus.Active:
      return ClientStatusDTO.ACTIVE;
    case ClientStatus.Archived:
      return ClientStatusDTO.ARCHIVED;
    default:
      return ClientStatusDTO.ACTIVE;
  }
};
